module.exports = __webpack_public_path__ + "static/media/LeopardDistribution_old.af428ea3.png";